import trim from 'lodash/trim';
import sanitizeHtml from 'sanitize-html';

const allowedTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'span',
  'strong',
  'b',
  'i',
  'mark',
  'small',
  'del',
  'em',
  'a',
  'br',
  'ul',
  'ol',
  'li'
];

export const onlyTextTags = (text?: string, allowedTag = true) => {
  if (!text) return '';

  const cleanText = sanitizeHtml(text, {
    allowedTags: allowedTag ? allowedTags : []
  });

  return trim(cleanText);
};
